module.exports = __webpack_public_path__ + "media/images/logo-b087c2a5c3615f6a04182edb8321d96b.svg";